import { createSelector } from 'reselect';

const selectBluePrintRegistries = (state: any) => state.bluePrintRegistries;


export const selectBluePrintRegistriesCurrentItem = createSelector([selectBluePrintRegistries], (bluePrintRegistries) => bluePrintRegistries.current);

export const selectBluePrintRegistriesListItems = createSelector([selectBluePrintRegistries], (bluePrintRegistries) => bluePrintRegistries.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectBluePrintRegistriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBluePrintRegistriesQueryItems = createSelector([selectBluePrintRegistries], (bluePrintRegistries) => bluePrintRegistries.query);

export const selectBluePrintRegistriesCreatedItem = createSelector([selectBluePrintRegistries], (bluePrintRegistries) => bluePrintRegistries.create);

export const selectBluePrintRegistriesCompareItem = createSelector([selectBluePrintRegistries], (bluePrintRegistries) => bluePrintRegistries.compare);

export const selectBluePrintRegistriesUpdatedItem = createSelector([selectBluePrintRegistries], (bluePrintRegistries) => bluePrintRegistries.update);

export const selectBluePrintRegistriesReadItem = createSelector([selectBluePrintRegistries], (bluePrintRegistries) => bluePrintRegistries.read);

export const selectBluePrintRegistriesDeletedItem = createSelector([selectBluePrintRegistries], (bluePrintRegistries) => bluePrintRegistries.delete);

export const selectBluePrintRegistriesSearchedItems = createSelector([selectBluePrintRegistries], (bluePrintRegistries) => bluePrintRegistries.search);

export const selectBluePrintRegistriesItemsCount = createSelector([selectBluePrintRegistries], (bluePrintRegistries) => bluePrintRegistries.count);

export const selectBluePrintRegistriesItemsFilter = createSelector([selectBluePrintRegistries], (bluePrintRegistries) => bluePrintRegistries.filter);